module.exports = __webpack_public_path__ + "static/TT-Tour_Flyer-7734b53f3772cc89728d3bbd7fb72e0c.pdf";